module.exports = __webpack_public_path__ + "img/dom-labs.5af19849.svg";